<!-- eslint-disable vue/no-v-html -->
<template>
  <div v-if="reportDataComp">
    <div id="sticky-wrapper" class="sticky-header">
      <div v-if="reportDataComp.code !== 500 && reportDataComp.code !== 404" class="sticky-title has-side-bars">
        <!-- eslint-disable-next-line vue/no-parsing-error -->
        <h2>{{ isMobile ? (reportDataComp[0].title.length <= 80 ? reportDataComp[0].title : reportDataComp[0].title.slice(0, 77) + '...') : (reportDataComp[0].title.length <= 100 ? reportDataComp[0].title : reportDataComp[0].title.slice(0, 97) + '...') }}</h2>
      </div>
    </div>
    <div v-if="reportDataComp.code === 500 || reportDataComp.code === 404 || reportDataComp.length === 0" class="cms-error">
      <div id="box-observer" />
      <span>{{ reportDataComp.code === 404 ? $t('not_cms_lang') : $t('not_cms') }}</span>
    </div>
    <div v-else class="report-page has-side-bars">
      <div class="report-wrap">
        <div id="box-observer" class="report-text">
          <span class="report-title" v-html="reportDataComp[0].title" />
          <span v-cms="reportDataComp[0].description" class="report-desc" />
        </div>
        <div class="btn btn--light " :class="isMobile ? 'btn--circle' : 'btn--small'" @click="show">
          <div class="btn-icon btn-icon--share" />
          <div v-if="!isMobile" class="btn-text">{{ $t('share') }}</div>
        </div>
        <ModalShare :modal-close="hide" :data-title="reportDataComp[0].title" />
      </div>
      <div class="report-content-wrap">
        <!--div v-cms="reportDataComp[0].index" class="index-wrap" /-->
        <div class="index-wrap">
          <ReportIndexMobile v-if="isMobile" :index-arr="reportDataComp[0].indexArr" />
          <ReportIndex v-if="!isMobile" :index-arr="reportDataComp[0].indexArr" />
        </div>
        <div v-cms="reportDataComp[0].htmldefinition" class="report-def" />
      </div>
    </div>
  </div>
  <div v-else class="loader">
    <Loader :text="$t('loading')" />
  </div>
</template>

<script>
import { vCmsHtml as cms, getCMSReport } from '@/services/graphql'
import Loader from '../components/Loader.vue'
import ModalShare from '../components/modals/ModalShare.vue'
import ReportIndex from './ReportIndex.vue'
import ReportIndexMobile from './ReportIndexMobile.vue'

const io = new IntersectionObserver(
  entry => {
    if (document.querySelector('#sticky-wrapper')) {
      // Remove 'title-grow' class if observation target is inside viewport
      if (entry[0].intersectionRatio > 0) {
        document.querySelector('#sticky-wrapper').classList.remove('title-grow')
      }
      // Add 'title-grow' class otherwise
      else {
        if (entry[0].boundingClientRect.y < entry[0].rootBounds.y)
          document.querySelector('#sticky-wrapper').classList.add('title-grow')
      }
    }
  },
  {
    rootMargin: '-112px',
  }
)

export default {
  components: { Loader, ModalShare, ReportIndex, ReportIndexMobile },
  directives: { cms },
  props: {},
  data() {
    return {
      reportDataComp: null,
    }
  },
  watch: {
    reportData() {
      this.reportDataComp = this.reportData
    },
  },
  asyncComputed: {
    reportData() {
      return getCMSReport(this.$store.state.i18n.lang, this.$route.params.reportId)
    },
  },
  updated() {
    io.observe(document.querySelector('#box-observer'))
  },
  destroyed() {
    io.disconnect()
  },
  methods: {
    show() {
      this.$modal.show('modal-share', { url: window.location.href.split('#')[0], dataTitle: this.reportDataComp[0].title })
    },
    /**
     * Hide the modal "modal-share"
     * @public This is a public method
     */
    hide() {
      this.$modal.hide('modal-share')
    },
  },
}
</script>

<style lang="stylus" scoped>
.sticky-header
  position: fixed
  top: $subheader-height
  z-index: 6
  display: none
  width: 100%
  height: vw(60px)
  border-bottom: 1px solid $bcn-other-grey
  background: linear-gradient(135deg, rgba(#54AEEF, 0.05) 0, rgba(#7360EA, 0.05) 100%)
  background-color: #fff

  .sticky-title
    display: flex
    align-items: center
    gap: vw(15px)

    h2
      m-font-size(24, 28)
      font-weight: 600
      margin-block-start: 0
      margin-block-end: 0

      .mobile &
        m-font-size(18, 22)

.title-grow
  display: flex
  transform-origin: top center
  animation: growDown 0.2s ease-in-out forwards

.report-page
  display: flex
  flex-direction: column
  margin-top: vw(30px)
  margin-bottom: vw(20px)
  min-height: "calc(100vh - %s - %s - %s - %s)" % ($header-height $subheader-height $footer-height vw(50px))
  gap: vw(6px)
  
  >>>.iframe-wrapper
    display: flex
    justify-content: center
    
    iframe
      .mobile &
        width: 100% !important

  .report-wrap
    display: flex
    justify-content: space-between
    padding-bottom: vw(25px)
    width: 100%

    .btn
      height: max-content

    .report-text
      display: flex
      flex-direction: column
      gap: vw(20px)

      .report-title
        m-font-size(30, 34)
        color: black
        font-weight: 600

      .report-desc
        m-font-size(18, 22)
        color: $grey-dark
        font-weight: 400

  .report-content-wrap
    display: flex
    align-items: flex-start
    gap: vw(30px)
    
    .mobile &
      display: block

    .index-wrap
      position: sticky
      top: "calc(%s + %s + %s + %s)" % ($header-height $subheader-height vw(10px) vw(60px))
      flex: 0 0 vw(250px)
      z-index: 11
      padding: vw(10px)
      width: vw(250px)
      border-radius: 8px
      background-color: #fff
      box-shadow: 0 4px 80px 0 rgba(0, 0, 0, 0.05)

      .mobile &
        margin-bottom: 20px
        position: sticky
        margin-left: vw(-20px)
        width: 'calc(100% + %s)' % (vw(40px))
        padding: vw(15px) vw(20px)
        background-color: #fff
        height: auto
        top: "calc(%s + %s + %s)" % ($header-height $subheader-height vw(60px))
        border-bottom: 1px solid $grey-grey
        border-radius: 0px

  .report-def
    m-font-size(16, 24)
    padding: vw(30px)
    width: 100%
    background-color: #fff
    // box-shadow: 0 0 10px rgba(#000, 0.05)
    color: black

    .mobile &
      margin-right: 0

    >>> h2
      m-font-size(32, 42)
      margin-top: 0
      margin-bottom: vh(20px)
      font-weight: 600

    >>> h3
      m-font-size(26, 36)
      margin-top: 0
      margin-bottom: vh(20px)
      font-weight: 600

    >>> h4
      m-font-size(20, 30)
      margin-top: 0
      margin-bottom: vh(20px)
      font-weight: 400

    >>> p
      m-font-size(16, 26)
      margin-top: 0
      margin-bottom: vh(15px)
      font-weight: 300

    >>> hr
      margin-top: vh(30px)
      margin-bottom: vh(30px)
      height: 1px
      border: none
      background-color: $grey-grey

    >>> iframe
      display: block
      margin-top: vh(30px)
      margin-bottom: vh(30px)
      border: none

    >>> .row
      display: flex
      gap: vw(30px)
      
      .mobile &
        flex-direction: column

      .left,
      .right
        flex: 1 1 0%
        
        .mobile &
          width: 100% !important

    >>> a
      color: $corporate_color
      text-decoration: none

      &:hover
        color: $corporate_color
        text-decoration: underline
        cursor: pointer

    >>> li
      margin-left: vw(20px)
      padding: 0
      list-style-type: disc

    >>> .anchor
      position: relative
      top: vw(-130px)
      
      .mobile &
        top: vw(-192px)

.cms-error
  display: flex
  justify-content: center
  align-items: center
  min-height: "calc(100vh - %s - %s - %s - %s)" % ($header-height $subheader-height $footer-height vw(50px))

  span
    m-font-size(20, 26)
    color: black
    font-weight: 400

.loader
  min-height: "calc(100vh - %s - %s - %s - %s)" % ($header-height $subheader-height $footer-height vw(50px))

@keyframes growDown
  0%
    transform: scaleY(0)

  100%
    transform: scaleY(1)
</style>
